import {SelectableModel} from '../common/base/selectable-model';
import {DmsElementMetadataReg} from '../dms-element-metadata-reg';

export class DmsDocClassType extends SelectableModel {
  code: string;
  description: string;
  metadata: DmsElementMetadataReg[] = [];

}
